var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('spritesheet-gallery',_vm._g({attrs:{"images":_vm.images,"load-more":_vm.loadMore}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }